import script from "./SoldiersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SoldiersComponent.vue?vue&type=script&setup=true&lang=js"

import "./SoldiersComponent.vue?vue&type=style&index=0&id=31206974&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31206974"]])

export default __exports__